angular.module('rjmNg.controllers').controller('dashNavMenuCtrl', [
  "$scope"
  "$routeParams"
  "$window"
  "$location"
  "$http"
  "dashboardService"
  "$modal"
  "appRoute"
  "$q"
  "app"
  "$clientAppUrl"
  "Session"
  "Users"
  "$rootScope"
  "userEventService"
  "$clientUrl"
  "$templateCache"
  "Charts"
  "reportBuilder"
  "InputConnections"
  "tourTypes"
  "tourService"
  "MOBILE_WIDTH"
  (
    $scope
    $routeParams
    $window
    $location
    $http
    dashboardService
    $modal
    appRoute
    $q
    app
    $clientAppUrl
    Session
    Users
    $rootScope
    userEventService
    $clientUrl
    $templateCache
    Charts
    reportBuilder
    InputConnections
    tourTypes
    tourService
    MOBILE_WIDTH
  ) ->

    $scope.numberOfFailingConnections = -1

    $scope.navBarLocked = false

    Users.get app.getUserId()
    .then (user) ->
      $scope.user = user
      $scope.currentEmailInput = $scope.user.email
      $scope.currentUserName = $scope.user.name

    $scope.isMobile = () ->
      $window.innerWidth <= MOBILE_WIDTH

    $scope.getClientName = (name) ->
      return name

    $scope.clients = app.getClients()
    $scope.clientName = app.getClientName()
    $scope.clientId = app.getClientId()

    $scope.isActive = (dashId) ->
      dashId is +$routeParams.dashId

    $scope.isActiveClient = (clientId) ->
      clientId is $scope.clientId
    $scope.canAccessSettings = ->
      app.userHasImplementedClients() || app.isSupportUserSession()

    # Check to see if we're on a dashboard, or the dashapp page if we have no dashboards
    $scope.isOnDashboard = ->
      return $routeParams.dashId? or $location.$$absUrl.match('dashapp')

    # Do we have any dashboards at all for this client?
    $scope.hasDashboards = app.getDashboards()?.length > 0

    $scope.dashboardUrl = ->
      user = app.getUser()
      defaultDash = app.getDefaultDashboard()
      if defaultDash? and not user.curtain
        $clientAppUrl("/#{+defaultDash.id}")
      else
        $clientAppUrl("/")

    $scope.getClientUrl = (clientId) ->
      appRoute("/", clientId)

    $scope.destroySession = () ->
      Session.destroy().finally () ->
        $window.location = "/v2/session/create"

    ######################### BEGIN TOUR CODE

    # don't show the tour by default in support dropdown
    $scope.showTourOptions = false

    $scope.vrbTour = tourTypes.VRB_TOUR
    $scope.dashTour = tourTypes.DASH_TOUR

    $scope.tourCompleteStatus =
      dashboard: false
      vrb: false
      gaConnected: false

    $scope.tourUrl =
      dashboard: $scope.dashboardUrl()
      vrb: $clientAppUrl("/reports/create")
      ga: $clientUrl '/google/authorize?feature=Analytics'


    $scope.reportName = ""

    getTourInfo = () ->
      tourService.getVrbChart().then ((chart) ->
        $scope.reportName = "'" + chart.name + "'"
        figureId = chart.figureId
        $scope.tourUrl.vrb = tourService.getVrbUrl(figureId)
      )
    getTourInfo()

    isGaConnected = () ->
      InputConnections($scope.clientId).get(true)
        .then((connections) ->
          connectionList = connections
          for connection in connectionList
            if connection.type is 'google_analytics' and connection.properties.feature is "analytics"
              $scope.tourCompleteStatus.gaConnected = true
              return
        )
    isGaConnected()


    # Queue up the user event service to keep track of completed, dismissed, and ended tours
    $q.all([
      userEventService.getTourCompletedEvents(),
      userEventService.getTourSkippedEvents(),
      userEventService.getDismissedTour(),
      userEventService.getBringTourBack(),
      userEventService.getCompletedDashTour(),
    ]).then(([completedEvents, skippedEvents, dismissedTour, bringTourBack, completedVrbTour, completedDashTour]) ->

      numberOfDismissedRecords = dismissedTour?.data?.length - 1
      lastTimeTourWasDismissed = dismissedTour?.data[numberOfDismissedRecords]?.id or 0

      numberOfBringTourBackRecords = bringTourBack?.data?.length - 1
      lastTimeTourWasBroughtBack = bringTourBack?.data[numberOfBringTourBackRecords]?.id or 0

      if dismissedTour? or bringTourBack?
        $scope.showTourOptions = lastTimeTourWasBroughtBack > lastTimeTourWasDismissed

      $scope.tourCompleteStatus.vrb = completedVrbTour?.data?.length > 0
      $scope.tourCompleteStatus.dashboard = completedDashTour?.data?.length > 0
    )

    # Code for opening the guide
    $scope.openTour = () ->
      $scope.showTourOptions = true
      userEventService.logBringTourBack()
    # Code for getting rid of the guide in the dropdown
    $scope.dismissTour = () ->
      $scope.showTourOptions = false
      userEventService.logDismissedTour()

    # First Step: Launch Modal, controlled by tourWelcomeCtrl
    # The modal then broadcasts beginTourSteps
    $scope.tourWelcomeModal = (tourType)->
      if tourType is tourTypes.DASH_TOUR
        modal = $modal(
          modalClass: 'tour-welcome-modal'
          template: 'modal.tourWelcome.html'
          show: true
          backdrop: 'static'
          keyboard: false
          scope: $scope.$new()
          priority: -20
        )

      if tourType is tourTypes.VRB_TOUR
        modal = $modal(
          modalClass: 'tour-welcome-modal'
          template: 'modal.vrbTourWelcome.html'
          show: true
          backdrop: 'static'
          keyboard: false
          scope: $scope.$new()
          priority: -20
        )

    # Broadcast by modal
    $scope.$on('beginTourSteps', (e, tourType) ->
      dashboardService.toggleTouringMode(true)
      $scope.startTour(e, tourType)
      )

    # Broadcast by dashWrapperCtrl after checking Implemented Clients, etc.
    # This might need to be updated to start $scope.tourWelcomeModal(tourType)
    $scope.$on('startTourForFirstTime', () ->
      $scope.tourWelcomeModal(tourTypes.DASH_TOUR)
      )

    # Start of the actual Tour Steps
    $scope.startTour = (logEvent, tourType) ->
      tourEnd = false
      steps = []

      tourOver = ->
        $rootScope.$broadcast('endOfTour')
        # only log if the user got through all the steps
        if tourEnd
          if tourType is tourTypes.VRB_TOUR
            userEventService.logCompletedVrbTour()
            $scope.tourCompleteStatus.vrb = true

          if tourType is tourTypes.DASH_TOUR
            userEventService.logCompletedDashTour()
            $scope.tourCompleteStatus.dashboard = true

        dashboardService.toggleTouringMode(false)
        dashboardService.readyForCallToAction()
        $scope.$apply() # this is here to force the disable property to update the gridsterDirective

      tourState = {}
      jsObjectStorage = {
        getItem: ((key) -> tourState[key]),
        setItem: ((key, value) -> tourState[key] = value)
      }

      cacheTemplate = (templateUrl) ->
        $http.get(templateUrl, cache: true).then(
          (response) -> $templateCache.put templateUrl, response.data
        )

      tourPopoverTemplate = (stepNumber, options) ->
        # profile to find out why this is crazy slow now
        template = $templateCache.get "popover.tourStep.html"

        if stepNumber == steps.length - 1
          tourEnd = true
          template = $templateCache.get "popover.tourEnd.html"

        return template

      setTourStep = (tour, step) ->
        $el = $(tour?._steps?[step]?.element)
        dashboardService.setTourStep($el.data('step'))

        # this ensures filters are opened and then closed
        if tourType is tourTypes.VRB_TOUR and (steps[step].stepOrder is "4")
          $el.triggerHandler('click')

      getTourSteps = ->
        steps = []

        getElementTourData = (index, el) ->
          steps.push {
            element: el,
            content: el.getAttribute('data-intro')
            placement: el.getAttribute('data-tour-placement') or 'right'
            stepOrder: el.getAttribute('data-step')
          }

        angular.element('[data-step]').sort((a, b) ->
          a.getAttribute('data-step') - b.getAttribute('data-step')
        ).each(getElementTourData)
        $scope.numberOfSteps = steps.length
        return steps # skip to add chart to test showing dropdown

      # log a userevent with the tour data-step
      logTourEvent = (done) ->
        userEventService.logEvent +@element.getAttribute('data-step')

        return null  # don't return a promise for bootstrap-tour to wait for

      tour = new Tour(
        storage: jsObjectStorage
        onShow: setTourStep
        onEnd: tourOver
        onNext: logTourEvent
        template: tourPopoverTemplate
      )

      steps = getTourSteps()  # tourPopoverTemplate uses steps var
      tour.addSteps steps

      tour.start()

    ######################## END TOUR CODE

    $rootScope.$on "updateNotificationCount", (e, failingConnectionsNumber, loadingConnectionInformation) ->
      $scope.numberOfFailingConnections = failingConnectionsNumber

    $scope.$on('lockNavBar', () ->
      $scope.navBarLocked = true
      )

    $scope.$on('unlockNavBar', () ->
      $scope.navBarLocked = false
      )

    $scope.hideFreeTrialBillingModal = () ->
      $rootScope.$broadcast('hideFreeTrialBillingModal')

])
